import React, { useState } from "react";
import { prodDropdown } from "./NavItems";
import { Link } from "react-router-dom";
import "./Dropdown.css";

function ProdDropdown() {
  const [proddropdown, setProdDropdown] = useState(false);
  return (
    <>
      <ul
        className={proddropdown ? "prod-submenu clicked" : "prod-submenu"}
        onClick={() => setProdDropdown(!proddropdown)} > {
          prodDropdown.map((item) => {
            return (
              <li key={item.id}>
                <Link to={item.path} className={item.cName} onClick={() => setProdDropdown(false)}>
                  {item.title}
                </Link>
              </li>
            );
          })
        } </ul>
    </>
  );
}

export default ProdDropdown;
